import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef8a0f6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commondelete" }, null, -1))
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_resultItem = _resolveComponent("resultItem")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mygroup", _ctx.theme])
  }, [
    (_ctx.groups && _ctx.groups.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groups, (item, idx) => {
          return (_openBlock(), _createBlock(_component_a_card, {
            key: 'card' + idx,
            title: item.groupName,
            class: _normalizeClass({'active': _ctx.active === idx}),
            bordered: false,
            onClick: ($event: any) => (_ctx.handleClick($event,idx, item))
          }, {
            extra: _withCtx(() => [
              _createVNode(_component_a_popconfirm, {
                title: "删除后不可撤销",
                overlayClassName: "tooltipstyle",
                placement: 'bottomRight',
                "ok-text": "删除",
                "cancel-text": "取消",
                onConfirm: ($event: any) => (_ctx.deleteItem(idx, item)),
                "get-popup-container": _ctx.getCalendarContainer,
                arrowPointAtCenter: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["onConfirm", "get-popup-container"]),
              _createElementVNode("span", {
                class: "commonedit",
                onClick: ($event: any) => (_ctx.edit(idx))
              }, null, 8, _hoisted_2)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_resultItem, {
                item: item,
                theme: _ctx.theme,
                showDelete: false
              }, null, 8, ["item", "theme"])
            ]),
            _: 2
          }, 1032, ["title", "class", "onClick"]))
        }), 128))
      : (_openBlock(), _createBlock(_component_Nodata, {
          key: 1,
          customdesc: '暂无组合数据',
          mode: 'vertical'
        }))
  ], 2))
}